export { ServiceTicketsComponent } from './service-tickets.component';
export { ServiceTicketsTableComponent } from './components/service-tickets-table/service-tickets-table.component';
export { ServiceTicketDetailsComponent } from './components/service-ticket-details/service-ticket-details.component';
export { TicketDetailsComponent } from './components/ticket-details/ticket-details.component';
